import { ExclamationOctagonFill } from "react-bootstrap-icons";
import { useArsContext } from "./ArsContextProvider";

/**
 * Check if the listing is being built from multiple datasets and display a warning if so.
 *
 * @returns A warning message if multiple datasets are in use, otherwise null
 */
export const MultipleDatasetCheck = () => {
  const { state } = useArsContext();

  return Array.from(state.datasetsInUse).filter((d) => d !== "ADSL").length <= 1 ? null : (
    <div className={`text-danger`}>
      <ExclamationOctagonFill />
      <span className="mx-1">
        The listing is being built from multiple datasets (
        {Array.from(state.datasetsInUse).join(", ")}).
      </span>
      <small>This may result in unexpected behaviour.</small>
    </div>
  );
};

MultipleDatasetCheck.displayName = "MultipleDatasetCheck";
